import { TFunction } from 'i18next';
import { useMemo } from 'react';
import { C_Ca_Visibility_Status } from '../../../../../../graphql/generatedModel.ts';
import { ISelectProps } from '../../../../../../shared/components/form/fields/select.component.tsx';

export const getVisibilityOptions = (t: TFunction) => {
  return useMemo<ISelectProps['options']>(
    () => [
      {
        id: C_Ca_Visibility_Status.CAVS1_ALWAYS,
        label: t(`enums.${C_Ca_Visibility_Status.CAVS1_ALWAYS}`),
      },
      {
        id: C_Ca_Visibility_Status.CAVS2_ONLY_CR_MODE,
        label: t(`enums.${C_Ca_Visibility_Status.CAVS2_ONLY_CR_MODE}`),
      },
      {
        id: C_Ca_Visibility_Status.CAVS3_ONLY_ORDER_MODE,
        label: t(`enums.${C_Ca_Visibility_Status.CAVS3_ONLY_ORDER_MODE}`),
      },
      {
        id: C_Ca_Visibility_Status.CAVS4_DISABLED,
        label: t(`enums.${C_Ca_Visibility_Status.CAVS4_DISABLED}`),
      },
    ],
    [t],
  );
};
